var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "my-loading",
          rawName: "v-my-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "task-center",
      style: { background: _vm.isHidden == 1 ? "#24252A" : "#fff" }
    },
    [
      _vm.isHidden == 2 || _vm.isHidden == 0
        ? _c(
            "div",
            { staticClass: "no-task flex column" },
            [
              _c(
                "van-empty",
                {
                  staticClass: "custom-image",
                  attrs: { description: _vm.$t("300114") }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: { slot: "image", "aria-hidden": "true" },
                      slot: "image"
                    },
                    [_c("use", { attrs: { "xlink:href": "#icon-jilu1" } })]
                  )
                ]
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("300115")))])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isHidden == 1
        ? _c(
            "div",
            {
              staticClass: "task-center-banner",
              style: { backgroundImage: "url(" + _vm.bannerUrl + ")" }
            },
            [
              _c("h1", [_vm._v(_vm._s(_vm.$t("310001")))]),
              _vm._v(" "),
              _c("p", { staticStyle: { "margin-bottom": "2rem" } }, [
                _vm._v(_vm._s(_vm.$t("300110")))
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isHidden == 1
        ? _c("div", { staticClass: "task-container" }, [
            _c("ul", { staticClass: "tabs flex-center" }, [
              _c(
                "li",
                {
                  staticClass: "tab-item bold pointer active",
                  on: {
                    click: function($event) {
                      return _vm.changeTab("task")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("310001")))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "tab-item bold pointer",
                  on: {
                    click: function($event) {
                      return _vm.changeTab("rule")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("310000")))]
              )
            ]),
            _vm._v(" "),
            _c("div", { attrs: { id: "task" } }, [
              _c("div", { staticClass: "title" }, [
                _c("div", { staticClass: "flex-center" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: { slot: "image", "aria-hidden": "true" },
                      slot: "image"
                    },
                    [
                      _c("use", {
                        attrs: { "xlink:href": "#icon-renwuzhongxin" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("h1", { staticClass: "bold" }, [
                    _vm._v(_vm._s(_vm.$t("310001")))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "task-list" },
                _vm._l(_vm.taskList, function(item) {
                  return _c(
                    "li",
                    {
                      key: item.id,
                      staticClass: "task-list-item flex-between"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "left-content",
                          class: _vm.isDirection
                            ? "left-content-rtl"
                            : "left-content-ltr"
                        },
                        [
                          _c("p", { staticClass: "bold" }, [
                            _vm._v(_vm._s(_vm.$t(item.title)))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex-center" }, [
                            _c(
                              "svg",
                              {
                                staticClass: "icon",
                                attrs: { slot: "image", "aria-hidden": "true" },
                                slot: "image"
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-a-Group38695" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "bold inline-block uppercase" },
                              [
                                _vm._v(
                                  "+ " +
                                    _vm._s(item.amount) +
                                    " " +
                                    _vm._s(item.currency)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            item.type == "3" ||
                            item.type == "4" ||
                            item.type == "5" ||
                            item.type == "6"
                              ? _c(
                                  "a",
                                  {
                                    attrs: { href: item.linkList[_vm.language] }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-tishi"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "right-button flex column" },
                        [
                          _c(
                            "van-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    item.type == "3" ||
                                    item.type == "4" ||
                                    item.type == "5",
                                  expression:
                                    "item.type == '3' || item.type == '4' || item.type == '5'"
                                }
                              ],
                              staticClass: "first-btn",
                              on: {
                                click: function($event) {
                                  return _vm.handleButton(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("buttonFilter")(item.type, _vm.$i18n)
                                  ) +
                                  "\n              "
                              ),
                              _c("van-icon", {
                                attrs: {
                                  name: _vm.isDirection ? "arrow-left" : "arrow"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "van-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !item.completed &&
                                    item.type != "7" &&
                                    item.type != "8",
                                  expression:
                                    "!item.completed && item.type != '7' && item.type != '8'"
                                }
                              ],
                              staticClass: "form-btn",
                              on: {
                                click: function($event) {
                                  return _vm.handleClick(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("buttonFilter2")(
                                      item.type,
                                      _vm.$i18n
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "van-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.completed && item.type != 9,
                                  expression: "item.completed && item.type != 9"
                                }
                              ],
                              staticClass: "completed-btn",
                              attrs: { disabled: "" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("300109")) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "van-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.completed && item.type == 9,
                                  expression: "item.completed && item.type == 9"
                                }
                              ],
                              staticClass: "completed-btn",
                              attrs: { disabled: "" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    item.completed == 2
                                      ? _vm.$t("300122")
                                      : _vm.$t("300109")
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.type == "7" || item.type == "8",
                                  expression:
                                    "item.type == '7' || item.type == '8'"
                                }
                              ],
                              staticClass: "flex column"
                            },
                            [
                              _c("span", { staticClass: "block" }, [
                                _vm._v(_vm._s(_vm.$t("300105")))
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "block bold" }, [
                                _vm._v(
                                  _vm._s(_vm.isLogin ? item.completedNumber : 0)
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLogin && _vm.userInfo.isWhitelist,
                      expression: "isLogin && userInfo.isWhitelist"
                    }
                  ],
                  staticClass: "block completed"
                },
                [_vm._v(_vm._s(_vm.$t("300091")))]
              )
            ]),
            _vm._v(" "),
            _c("div", { attrs: { id: "rule" } }, [
              _c("div", { staticClass: "title" }, [
                _c("div", { staticClass: "flex-center" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: { slot: "image", "aria-hidden": "true" },
                      slot: "image"
                    },
                    [
                      _c("use", {
                        attrs: { "xlink:href": "#icon-jiesuorenwu" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("h1", { staticClass: "bold" }, [
                    _vm._v(_vm._s(_vm.$t("310000")))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "user-reward" }, [
                _c("div", { staticClass: "flex column" }, [
                  _c("div", { staticClass: "item flex-between" }, [
                    _c("p", { staticClass: "inline-block" }, [
                      _vm._v(_vm._s(_vm.$t("300079")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "inline-block bold uppercase" }, [
                      _vm._v(
                        _vm._s(
                          _vm.isLogin
                            ? _vm.fixNumber(_vm.awardObj.totalFreeze, 6)
                            : "--"
                        ) + " SCS"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "van-button",
                      {
                        staticClass: "form-btn",
                        on: { click: _vm.handleTrade }
                      },
                      [_vm._v(_vm._s(_vm.$t("300083")))]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "rule-clause" }, [
                _c("div", {
                  staticClass: "rule-content",
                  domProps: { innerHTML: _vm._s(_vm.ruleContent) }
                })
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "form-popup",
          attrs: { round: "" },
          model: {
            value: _vm.popupShow,
            callback: function($$v) {
              _vm.popupShow = $$v
            },
            expression: "popupShow"
          }
        },
        [
          _c("div", { staticClass: "form-popup-container" }, [
            _c(
              "p",
              { staticClass: "title bold flex-between" },
              [
                _vm._v(_vm._s(_vm.$t("300093")) + "\n        "),
                _c("van-icon", {
                  attrs: { name: "cross" },
                  on: {
                    click: function($event) {
                      _vm.popupShow = false
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-box flex column" }, [
              _c("span", { staticClass: "label block" }, [
                _vm._v(
                  _vm._s(
                    _vm.modelType == "Twitter"
                      ? _vm.$t("300117")
                      : _vm.$t("300118")
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-text flex-center" }, [
                _c("em", { staticClass: "normal" }, [_vm._v("@")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.temp.account,
                      expression: "temp.account"
                    }
                  ],
                  staticClass: "value",
                  attrs: { type: "text", id: "accountInput" },
                  domProps: { value: _vm.temp.account },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.temp, "account", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "em",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errorMsg,
                      expression: "errorMsg"
                    }
                  ],
                  staticClass: "normal error-msg block"
                },
                [_vm._v(_vm._s(_vm.$t("300092", { type: _vm.modelType })))]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "buttons flex-between" },
              [
                _c(
                  "van-button",
                  {
                    staticClass: "cancel-btn",
                    on: {
                      click: function($event) {
                        _vm.popupShow = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("300119")))]
                ),
                _vm._v(" "),
                _c(
                  "van-button",
                  {
                    staticClass: "submit-btn",
                    on: {
                      click: function($event) {
                        return _vm.submitForm()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("300104")))]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tip-popup",
          attrs: { round: "" },
          model: {
            value: _vm.tipsPopup,
            callback: function($$v) {
              _vm.tipsPopup = $$v
            },
            expression: "tipsPopup"
          }
        },
        [
          _c("p", { staticClass: "tip-message" }, [
            _vm._v(_vm._s(_vm.$t("300082")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6adaa0b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6adaa0b4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/task.vue
// module id = SVAR
// module chunks = 0